import { ResultItem } from "@/services/private-office-service/types";

export const getPictures = (privateOffice: ResultItem["details"]) => {
  const pictures = [
    privateOffice.picture_url,
    privateOffice.picture_url1,
    privateOffice.picture_url2,
    privateOffice.picture_url3,
    privateOffice.picture_url4,
    privateOffice.picture_url5,
  ];

  return pictures.filter(Boolean);
};
